import { words, API_BASE_URL } from "./config"

export const fetchWord = async () => {
    let wordIndex = Math.floor(Math.random() * words.length)
    const url = `${API_BASE_URL}/${words[wordIndex]}`
    const response = await fetch(url)
    const data = await response.json()
    return {
        success: true,
        data: {
            word: data[0].word,
            partOfSpeech: data[0].meanings[0].partOfSpeech,
            definition: data[0].meanings[0].definitions[0].definition
        }
    }
}
